import React from "react";
import AuthRedcrossContext from "../../Context/AuthRedcrossContext";
import LayoutDefaultScreen from "./LayoutDefaultScreen";

type Props = {
  responeConfig: any;
};
const DefaultEproScreen = (props: Props) => {
  return (
    <AuthRedcrossContext>
      <LayoutDefaultScreen responeConfig={props.responeConfig} />
    </AuthRedcrossContext>
  );
};

export default DefaultEproScreen;
